import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(
    private titleService: Title,
    private metaService: Meta,
  ) {}

  updateTitle(title: string): void {
    this.titleService.setTitle(title);
  }

  updateDescription(desc: string): void {
    this.metaService.updateTag({ name: 'description', content: desc });
  }

  updateKeywords(keywords: string): void {
    this.metaService.updateTag({ name: 'keywords', content: keywords });
  }

  updateFavicon(href: string): void {
    const head = document.head;
    let link = head.querySelector<HTMLLinkElement>('#favicon');
    console.log('Updating favicon:', link);
    if (!link) {
      link = document.createElement('link');
      link.id = 'favicon';
      link.rel = 'shortcut icon';
      link.type = 'image/png';
      head.appendChild(link);
    }

    link.href = href;
  }
}
